
<template>
<div class="col-12">
  <button class="btn btn-primary"  @click="showModal()" type="button" >
    <font-awesome-icon icon="fas fa-plus-square" />&nbsp;Banco de imágenes
  </button>

  <b-modal ref="my-modal2" size="xl" hide-footer title="Banco de imágenes">


      <div class="row">
        <div class="col-6">
          <b-form-group
            id="input-group-3"
            label="Agregar Gráfica:"
            label-for="imagen"
          >
            <b-form-file
              accept="image/jpeg, image/png, image/jpg, image/svg+xml"
              id="graph"
              v-on:change="handleFilesUpload($event)"
              v-model="form.image"
              :placeholder="
                      this.form.image
                        ? this.form.image
                        : 'Seleccione una imágen en formato PNG, JPG o SVG.'
                    "
            ></b-form-file>
            <b-img
              v-if="this.form.image"
              :src="this.form.image"
              fluid
              alt="icon"
              style="
                        width: 350px;
                        margin-bottom: 25px;
                        margin-top: 10px;
                      "
            ></b-img>

          </b-form-group>
        </div>
        <div class="col-12">
          <b-button type="button" @click="saveImage()" class="mt-1 mb-5" variant="primary">Guardar</b-button>
        </div>

      </div>



    <div class="row">
    </div>
    <div class="row">
      <div class="col-12">
        <h3>Imágenes Guardadas</h3>
        <hr>
      </div>


      <div v-for="imagen in listaDeImagenes" :key="imagen">
        <div class="col-6">
          <img :src="'https://mobius-imgs.s3.amazonaws.com/' + imagen.replace('svg+xml', 'svg%2Bxml')" alt="Imagen" style="width: 200px; border: #d3d3d3 0.5px solid; padding: 5px">
          <b-button type="button" @click="addImage(imagen)" class="mt-4" variant="primary">Agregar</b-button>
        </div>
        <hr>
      </div>

    </div>

  </b-modal>

</div>
</template>

<script>
import axios from "axios";
import router from "@/router";

export default {
  data() {
    return {
      form: {
        imageName: '',
        image: ''
      },
      listaDeImagenes: [],
    }
  },
  mounted() {
   this.loadImages();
  },
  methods: {
    addImage(image) {
      this.$emit("addImage" , image)
      this.$refs['my-modal2'].hide();
    },
    loadImages() {
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/question/imagesList/lessonsImages", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          this.listaDeImagenes = response.data;
        })
        .catch(error => {
          console.error('Error al obtener la lista de imágenes', error);
        });
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    saveImage() {
      let loader = this.$loading.show({});

      axios.post(import.meta.env.VITE_API_BASE_URL + "/api/lessons/saveImage", this.form, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        }}).then((result) => {
        this.$toastr.defaultTimeout = 2000; // default timeout : 5000
        this.$toastr.defaultClassNames = ["animated", "zoomInUp"];
        this.$toastr.s(
          "Curso Guardado."
        );
        this.form.image = null;
        console.log(result);
        loader.hide();
        this.loadImages();

      }).catch((err) => {
        console.log(err.message);
        loader.hide();

      });
    },
    handleFilesUpload(e) {
      const file = e.target.files[0];
      this.form.imageName = URL.createObjectURL(file);
      this.getBase64(file).then((data) => (this.form.image = data));
    },
    showModal() {
      this.$refs['my-modal2'].show();
    }
  }
}
</script>


<style>
.modal-xl {
  max-width: 80% !important;

}
</style>
